function TableSkeleton({ rows = 5, columns = 4, hasHeader = true }) {
  return (
    <div className="overflow-x-auto border border-gray-300 rounded-md">
      <table className="w-full">
        {hasHeader && (
          <thead>
            <tr className="bg-gray-50 text-left text-xs uppercase tracking-wide text-gray-500">
              {Array(columns)
                .fill(null)
                .map((_, index) => (
                  <th key={`header-${index}`} className="px-4 py-3">
                    <div className="h-2.5 w-24 animate-pulse rounded-full bg-gray-200"></div>
                  </th>
                ))}
            </tr>
          </thead>
        )}
        <tbody className="divide-y divide-gray-100 bg-white">
          {Array(rows)
            .fill(null)
            .map((_, rowIndex) => (
              <tr key={`row-${rowIndex}`} className="text-gray-700">
                {Array(columns)
                  .fill(null)
                  .map((_, colIndex) => (
                    <td
                      key={`cell-${rowIndex}-${colIndex}`}
                      className="px-4 py-3"
                    >
                      <div
                        className={`h-2.5 animate-pulse rounded-full bg-gray-200 ${
                          colIndex === 0 ? "w-32" : "w-24"
                        }`}
                      ></div>
                    </td>
                  ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default TableSkeleton;
